// +----------------------------------------------------------------------
// | Desc:提示层库
// +----------------------------------------------------------------------
import Vue from 'vue';

// +----------------------------------------------------------------------
// | Desc:MSG提示信息封装，icon值见官网
// +----------------------------------------------------------------------
Vue.prototype.$msg = function (message, type, time = 1500, callback) {
    if (this.$isblank(type)) {
        type = "info";
    };
    this.$Message[type]({
        background: true,
        content: message,
        duration: time / 1000
    });
    if (typeof (callback) == 'function') {
        setTimeout(function () {
            callback();
        }, time);
    };
}

// +----------------------------------------------------------------------
// | Desc:alert提示信息封装，icon值见官网
// +----------------------------------------------------------------------
Vue.prototype.$alert = function (msg, type) {
    if (!type) {
        type = 'info';
    };
    const title = '提示信息';
    const content = '<p>' + msg + '</p>';
    switch (type) {
        case 'info':
            this.$Modal.info({
                title: title,
                content: content
            });
            break;
        case 'success':
            this.$Modal.success({
                title: title,
                content: content
            });
            break;
        case 'warning':
            this.$Modal.warning({
                title: title,
                content: content
            });
            break;
        case 'error':
            this.$Modal.error({
                title: title,
                content: content
            });
            break;
    }
}


// +----------------------------------------------------------------------
// | Desc:交互时候的提示信息
// +----------------------------------------------------------------------
// | Param:show{boolead} true显示加载层;false关闭加载层
// | Param:message 提示信息
// +----------------------------------------------------------------------
// | Reurn:void;
// +----------------------------------------------------------------------
Vue.prototype.$loading = function (show = true, message = '数据加载中...') {
    if (show) {
        this.$Message.loading({
            content: message,
            duration: 1000
        });
    } else {
        this.$Message.destroy();
    }
}


// +----------------------------------------------------------------------
// | Desc: 二次确认框
// +----------------------------------------------------------------------
Vue.prototype.$confirm = function (confirm, callback) {
    this.$Modal.confirm({
        title: confirm['title'] || "操作提示",
        content: '<p>' + confirm['msg'] || "您确认要执行该操作吗？" + '</p>',
        onOk: () => {
            callback && callback();
        }
    });
}

// +----------------------------------------------------------------------
// | Desc:表格选择改变事件处理
// +----------------------------------------------------------------------
Vue.prototype.$tableSeletChange = function (e, that) {
    that.selectedRows = that.$arrTocomma(e);
    if (that.selectedRows.length > 0) {
        that.$msg('您选中的数据：' + that.selectedRows);
    } else {
        that.$msg('您取消了选择');
    }
}


// +----------------------------------------------------------------------
// | Desc:打开图片
// +----------------------------------------------------------------------
Vue.prototype.$openImg = function (url, name) {
    var url = this.$httpImg(url);
    var name = name || '图片预览';
    this.$QHImgopen.url(url, name)
}